import { createContext, useContext, useEffect, useState } from 'react';
import posthog from 'posthog-js';
import config from '../config';

const PostHogContext = createContext();

export const usePostHog = () => {
  const context = useContext(PostHogContext);
  if (!context) {
    throw new Error('usePostHog must be used within a PostHogProvider');
  }
  return context;
};

export const PostHogProvider = ({ children }) => {
  const [isInitialized, setIsInitialized] = useState(false);

  useEffect(() => {
    // Debug logging
    console.log('PostHog Config:', {
      host: config.posthog.host,
      hasApiKey: !!config.posthog.apiKey
    });

    if (config.posthog.apiKey) {
      console.log('PostHog host:', config.posthog.host);
      
      posthog.init(config.posthog.apiKey, {
        api_host: config.posthog.host,
        capture_pageview: true,
        capture_pageleave: true,
        autocapture: true,
        disable_session_recording: false,
        enable_recording_console_log: true,
        enable_recording_network_payloads: true,
        session_recording: {
          maskAllInputs: true,
          maskTextInputs: true,
          maskAllText: false,
          recordCanvas: true,
        },
        opt_out_capturing_by_default: false,
        loaded: (posthog) => {
          console.log('PostHog loaded successfully');
          console.log('PostHog instance:', posthog);
          setIsInitialized(true);
        },
        bootstrap: {
          distinctID: null,
          isIdentifiedID: false,
          featureFlags: {},
          sessionRecording: {
            startTime: null,
            endTime: null,
            recordingId: null,
          },
        },
      });
    } else {
      console.warn('PostHog API key not found. Analytics will be disabled.');
      console.log('Available environment variables:', {
        VITE_ENV: import.meta.env.VITE_ENV,
        VITE_POSTHOG_API_KEY: import.meta.env.VITE_POSTHOG_API_KEY,
        VITE_POSTHOG_HOST: import.meta.env.VITE_POSTHOG_HOST
      });
      setIsInitialized(true);
    }

    // Cleanup function - PostHog doesn't have a shutdown method
    // The library handles cleanup automatically when the page unloads
    return () => {
      // Optional: You can add any custom cleanup here if needed
      console.log('PostHog provider unmounting');
    };
  }, []);

  const value = {
    posthog: config.posthog.apiKey ? posthog : null,
    isInitialized,
  };

  return (
    <PostHogContext.Provider value={value}>
      {children}
    </PostHogContext.Provider>
  );
}; 